import vueMainInstance from "../../main";
import "lodash";

const namespaced = true;

const state = {
  locations: localStorage.getItem("locations") === null ? [] : JSON.parse(localStorage.getItem("locations")),
  responses: [],
  pending: []
};

const getters = {
  getLocationText: state => (placeId, type = null) => {
    let location = state.locations.find(v => v.id === placeId && v.type === type);
    if (typeof location !== "undefined") {
      return location.text;
    } else {
      vueMainInstance.$store.dispatch("Location/getLocation", { placeId, type });
    }
    return "";
  }
};

const mutations = {
  addLocation(state, location) {
    if (typeof state.locations.find(v => v.id === location.id && v.type === location.type) === "undefined") {
      state.locations.push(location);
    }
  },
  saveToLocalStorage(state) {
    localStorage.setItem("locations", JSON.stringify(state.locations));
  },
  // addResponses(state, response) {}, // TODO
  addPending(state, pending) {
    state.pending.push(pending);
  },
  removePending(state, { placeId, type }) {
    state.pending.splice(
      state.pending.findIndex(v => v.placeId === placeId && type === type),
      1
    );
  }
};

const actions = {
  getLocation({ commit, state }, { placeId, type = null }) {
    let pending = state.pending.find(v => v.placeId === placeId && type === type);
    if (typeof pending !== "undefined") return pending.promise;
    let promise = new Promise((resolve, reject) => {
      if (placeId === null || placeId === "") return;
      if (typeof state.locations.find(v => v.id === placeId && v.type === type) !== "undefined") {
        resolve(state.locations.find(v => v.id === placeId && v.type === type));
        return;
      }
      let endpointAddress;
      if (type === null) {
        endpointAddress = "location/get-location-by-id";
      } else if (type === "train_station") {
        endpointAddress = "location/get-train-station-by-id";
      }
      vueMainInstance.axios
        .get(endpointAddress, { params: { id: placeId } })
        .then(resp => {
          let location = resp.data[0];
          location.type = type;
          commit("addLocation", location);
          commit("saveToLocalStorage");
          commit("removePending", { placeId, type });
          resolve(location);
        })
        .catch(err => {
          reject(err);
        });
    });
    commit("addPending", { placeId, type, promise });
    return promise;
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
